export const getters = {
  stock: (state: any) => state.stock,
  pagination: (state: any) => state.pagination,
  sort: (state: any) => state.sort,
  search: (state: any) => state.search
}
